<!--  -->
<template>
  <div class="user-handsel">
    <img src="@/assets/img/personalCenter/user-handsel.png" alt="" />
    <p>定金单不属于当前登录用户，请核实后再操作哦！</p>
    <button @click="toHome">返回首页</button>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    toHome() {
      this.$router.push({
        path: '/home',
        query: {
          code: 2,
        },
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.user-handsel {
  //   display: flex;
  //   justify-content: center;
  padding: 300px 0;
  > img {
    display: block;
    width: 145px;
    height: 167px;
    margin: 0 auto;
  }
  > p {
    padding: 43px;
    color: #333;
    font-weight: 400;
    font-size: 22px;
    text-align: center;
  }
  > button {
    display: block;
    width: 225px;
    height: 58px;
    margin: 0 auto;
    color: #ff6c02;
    font-weight: 400;
    font-size: 25px;
    background: #fff;
    border: 2px solid #ff6c02;
    border-radius: 29px;
  }
}
</style>
